import { motion } from "framer-motion";
import { TESTIMONIALS, STORIES } from "@/lib/data";
import { Quote } from "lucide-react";

const Stories = () => {
  return (
    <section
      id="stories"
      data-testid="stories-section"
      className="bg-[#F2EFE9] px-6 md:px-10 lg:px-16 py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1500px]">
        {/* Testimonials */}
        <div className="grid grid-cols-12 gap-6 mb-24 md:mb-32">
          <div className="col-span-12 md:col-span-5">
            <p className="overline mb-5">Kind Words</p>
            <h2
              data-testid="testimonials-heading"
              className="serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#2A2A2A]"
            >
              From the families <br />
              I've <span className="italic text-[#C48B71]">photographed</span>.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 grid gap-10">
            {TESTIMONIALS.map((t, i) => (
              <motion.figure
                key={t.name}
                data-testid={`testimonial-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                  duration: 0.8,
                  ease: [0.22, 1, 0.36, 1],
                  delay: i * 0.08,
                }}
                className="border-t border-[#E6E2DA] pt-8 relative"
              >
                <Quote
                  size={28}
                  strokeWidth={1}
                  className="text-[#C48B71] mb-4"
                />
                <blockquote className="serif text-2xl md:text-3xl font-light leading-snug text-[#2A2A2A]">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="serif text-lg text-[#2A2A2A]">{t.name}</span>
                  <span className="h-px w-8 bg-[#E6E2DA]" />
                  <span className="overline">{t.role}</span>
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>

        {/* Blog / Stories */}
        <div className="grid grid-cols-12 gap-6 mb-12 items-end">
          <div className="col-span-12 md:col-span-7">
            <p className="overline mb-5">Field Notes</p>
            <h2 className="serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#2A2A2A]">
              Stories from <span className="italic text-[#C48B71]">behind</span>{" "}
              the lens.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {STORIES.map((s, i) => (
            <motion.article
              key={s.title}
              data-testid={`story-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{
                duration: 0.85,
                ease: [0.22, 1, 0.36, 1],
                delay: i * 0.1,
              }}
            >
              <div className="img-hover aspect-[4/3] w-full bg-[#E6E2DA]">
                <img
                  src={s.image}
                  alt={s.title}
                  className="h-full w-full object-cover"
                  style={{ objectPosition: "center 25%" }}
                />
              </div>
              <div className="mt-5 flex items-center gap-3">
                <span className="overline text-[#C48B71]">{s.tag}</span>
                <span className="h-px w-6 bg-[#E6E2DA]" />
                <span className="overline">{s.date}</span>
              </div>
              <h3 className="serif text-2xl md:text-[1.7rem] mt-3 leading-snug text-[#2A2A2A]">
                {s.title}
              </h3>
              <p className="mt-3 text-[#5C5C5C] text-[0.98rem] leading-[1.8] font-light">
                {s.excerpt}
              </p>
              <a
                href="#contact"
                className="mt-4 inline-block overline link-underline text-[#2A2A2A]"
              >
                Read story
              </a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stories;
